<template>
  <div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Envio/Status</h4>
    </div>
    <div class="card text-center" style="padding:15px;" v-if="contrato && contrato.servicos">
      <form style="padding:15px;" class="text-center" method="post">
        <h4 class="mb-3">Proposta:</h4>
        <h3 class="mb-2">
          {{contrato.servicos.abreviacao}} - {{contrato.servicos.titulo}}
          <br />
          <small>{{contrato.codigoContratacao}}</small>
        </h3>
        <table class="table">
          <thead>
            <tr>
              <th class="text-left">Contratação</th>
              <th class="text-left">Preenchimento</th>
              <th class="text-left" v-if="contrato.tsReprovacao">Reprovação</th>
              <th class="text-left">Status</th>
              <th class="text-left" v-if="contrato.status == 'Finalizado'">Aprovada</th>
              <th class="text-left" v-if="contrato.cancelado">Cancelada</th>
              <th class="text-left" v-if="contrato.tsDownload">Download</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-left">{{formatData(contrato.tsContratacao)}}</td>
              <td class="text-left">{{formatData(contrato.contratacoesEVO13.tsPreenchimento)}}</td>
              <td
                class="text-left"
                v-if="contrato.tsReprovacao"
              >{{formatData(contrato.tsReprovacao)}}</td>
              <td class="text-left">{{contrato.status}}</td>
              <td
                class="text-left"
                v-if="contrato.status == 'Finalizado'"
              >{{formatData(contrato.tsAprovacao)}}</td>
              <td
                class="text-left"
                v-if="contrato.cancelado"
              >{{formatData(contrato.tsCancelamento)}}</td>
              <td class="text-left" v-if="contrato.tsDownload">{{formatData(contrato.tsDownload)}}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!contrato.status =='Finalizado'">
          <h4 class="mb-3">Alteração de status</h4>
          <div class="form-row">
            <div class="form-group col-md-6 offset-3">
              <label for="_form-periodo">Alterar status</label>
              <select
                @change="mudaStatus"
                v-model="cadastro.status"
                class="form-control"
                id="_form-periodo"
                required
              >
                <option value selected disabled></option>
                <option value="Dados reprovados">Dados reprovados</option>
                <option value="Em estudo">Em estudo</option>
                <option value="Finalizado">Finalizado</option>
              </select>
            </div>
            <div class="col-sm-12" v-if="reprovado">
              <h4 class="mb-3">Motivo da reprocação</h4>
              <vue-editor class="vEditor" v-model="cadastro.valor" :editor-toolbar="customToolbar" />
            </div>
          </div>
          <table class="table">
            <tbody>
              <tr v-if="contrato.reprovacaoMotivo" class="alert alert-danger">
                <td colspan="7" class="text-left">
                  <h4>Motivos da reprovação</h4>
                  <div v-html="contrato.reprovacaoMotivo"></div>
                </td>
              </tr>
              <tr>
                <td
                  colspan="7"
                  class="text-left"
                  v-if="cadastro.status == 'Finalizado' || contrato.status =='Finalizado'"
                >
                  <div class="text-center" v-if="!contrato.arquivoEstudo">
                    <div class="areaFoto" @click="$refs.filecontrato.click()">
                      <i class="icon-cloud-upload-alt"></i>

                      <input
                        type="file"
                        @change="OnFileSelected"
                        id="filecontrato"
                        name="foto"
                        ref="filecontrato"
                        style="display: none;"
                        class="form-control"
                        accept="image/*"
                        v-if="!contrato.arquivoEstudo"
                      />
                    </div>
                    <button
                      v-if="contrato.arquivoEstudo"
                      class="btn btn-danger"
                      @click.prevent="fnRemoveFoto"
                    >Remover arquivo</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="display: flex; jusify-content:flex-end">
            <button class="btn btn-primary ml-auto" @click.prevent="fnStatus">Salvar</button>
          </div>
        </div>
      </form>
      <div class=" text-center" @click="fnDownload()" v-if="contrato.status == 'Finalizado'">
        <i class="icon-download1 i-rounded i-xlarge" style="float:none;"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { getSuccess, clientKey, urlApi } from "@/global/utils";
import { VueEditor } from "vue2-editor";

import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

export default {
  data() {
    return {
      contrato: {},
      cadastro: {},
      reprovado: false,
      cadastroid: null,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      arquivo: [],
    };
  },
  components: { VueEditor },
  mounted() {
    this.fnGetContratacao();
  },
  methods: {
    OnFileSelected(event) {
      this.contrato.arquivoEstudo = event.target.files[0].name;
      this.arquivo.push(event.target.files[0]);
    },
    fnRemoveFoto() {
      this.contrato.arquivoEstudo = null;
    },
    OnUpload() {
      var self = this;
      let fd = new FormData();
      let file = self.arquivo[0];
      fd.append("files", file, file.name);
      this.$http
        .post("api/img/" + this.$route.params.codigoContrato + "/etapa13", fd)
        .then((res) => {
          console.log(res);
          this.carregado = true;
          this.arquivo = [];
        });
    },

    fnDownload() {
      const imgUrl =
        urlApi + "Upload/" + this.$route.params.codigoContrato + "/etapa13/";
      window.open(imgUrl + this.contrato.arquivoEstudo);
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY");
    },
    async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_13`)
        .then((res) => {
          this.contrato = res.data;
          if (res.data.contratacoesEVO13 != null) {
            this.cadastro = res.data.contratacoesEVO13;
          }
        })
        .catch(() => {});
    },
    async fnStatus() {
      let dados = {
        Data: this.$moment().format("YYYY-MM-DD HH:MM"),
        valor:
          this.cadastro.status == "Dados reprovados"
            ? this.cadastro.valor
            : this.contrato.arquivoEstudo
            ? this.contrato.arquivoEstudo
            : true,
        Tipo: this.cadastro.status,
        contratacaoId: this.contrato.contratacaoId,
      };
      await this.$http
        .put("/contratacao/status/admin/" + this.contrato.contratacaoId, dados)
        .then(() => {
          getSuccess();
          this.OnUpload();
        });
      this.fnGetContratacao();
    },

    mudaStatus() {
      if (this.cadastro.status == "Dados reprovados") {
        this.reprovado = true;
      } else {
        this.reprovado = false;
      }
    },
    convertToken(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async fnDeletar(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_12/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map((item) => item.etapaId).indexOf(val);
          this.content.splice(i, 1);
          getSuccess();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user {
  width: 120%;
}
</style>